<template>
  <v-app-bar color="#F5F5F5" :elevation="0" class="custom-app-bar">
    <v-app-bar-nav-icon
      @click.stop="drawer = !drawer"
      color="#6F6F6F"
      class="hover-icon"
      v-tooltip.bottom="drawer ? 'Fechar menu' : 'Abrir menu'"
    ></v-app-bar-nav-icon>
    <v-img
      eager
      max-width="200"
      :src="require('@/assets/imagens/FundoClaro_Horizontal.png')"
      class="logo-img"
    ></v-img>
    <v-spacer></v-spacer>
    <v-app-bar-title class="color-1 mr-5 text-center" style="flex: none">
      <h3
        class="main-title smooth-title"
        :class="{ 'with-breadcrumbs': $route.name && $route.name !== 'home' }"
      >
        Controle de Licenças
      </h3>
      <div
        class="breadcrumbs-bar d-flex justify-center"
        v-if="$route.name && $route.name !== 'home'"
      >
        <v-breadcrumbs :items="breadcrumbs" class="pa-0" style="background: transparent;">
          <template #divider>
            <v-icon color="primary" size="18">mdi-chevron-right</v-icon>
          </template>
        </v-breadcrumbs>
      </div>
    </v-app-bar-title>
    <v-spacer />
    <div class="logout-btn-wrapper" @mouseenter="hoverLogout = true" @mouseleave="hoverLogout = false">
      <v-btn icon color="error" @click="logout" title="Sair" class="logout-btn">
        <v-icon>mdi-logout</v-icon>
      </v-btn>
      <transition name="fade-logout">
        <span v-if="hoverLogout" class="logout-tooltip">Deseja sair?</span>
      </transition>
    </div>
  </v-app-bar>

  <v-navigation-drawer
    v-model="drawer"
    color="#F5F5F5"
    :scrim="false"
    class="custom-drawer"
    elevation="2"
  >
    <v-list density="default" class="pa-0">
      <v-list-item
        class="hover-icon drawer-item"
        style="font-size: 20px; color: #6F6F6F;"
        height="60px"
        v-for="(item, index) in itens"
        :key="index"
        :to="item.value"
        active-class="active"
        :prepend-icon="item.icon"
      >
        <v-list-item-title style="font-size: 20px;">
          {{ item.title }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
    <div class="drawer-footer">
      <v-divider class="my-2"></v-divider>
      <div class="text-caption text-center" style="color: #b0b0b0;">
        &copy; Alfameta Sistemas Específicos
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
export default {
  data: () => ({
    drawer: localStorage.getItem("drawerState") === "true",
    title: "",
    hoverLogout: false,
    itens: [
      { title: "Home", value: "/home", icon: "mdi-inbox" },
      { title: "Clientes", value: "/clientes", icon: "mdi-account-group" },
      { title: "Licenças", value: "/licencas", icon: "mdi-certificate" },
      { title: "Planos", value: "/planos", icon: "mdi-package-variant-closed" },
      { title: "Produtos", value: "/produtos", icon: "mdi-package-variant" },
      { title: "Municípios", value: "/municipios", icon: "mdi-city" },
      { title: "UF", value: "/ufs", icon: "mdi-map" },
      { title: "Configurações", value: "/configuracoes", icon: "mdi-cog" },
    ],
  }),
  computed: {
    breadcrumbs() {
      const map = {
        home: [{ title: "Home", to: "/home" }],
        clientes: [
          { title: "Home", to: "/home" },
          { title: "Clientes", to: "/clientes" }
        ],
        licencas: [
          { title: "Home", to: "/home" },
          { title: "Licenças", to: "/licencas" }
        ],
        "licenca-detalhe": [
          { title: "Home", to: "/home" },
          { title: "Licenças", to: "/licencas" },
          { title: "Detalhe da Licença", to: "" }
        ],
        planos: [
          { title: "Home", to: "/home" },
          { title: "Planos", to: "/planos" }
        ],
        produtos: [
          { title: "Home", to: "/home" },
          { title: "Produtos", to: "/produtos" }
        ],
        "editar-cliente": [
          { title: "Home", to: "/home" },
          { title: "Clientes", to: "/clientes" },
          { title: "Edição de Cliente", to: "" }
        ],
        "cadastro-cliente": [
          { title: "Home", to: "/home" },
          { title: "Clientes", to: "/clientes" },
          { title: "Cadastro de Cliente", to: "" }
        ],
        municipios: [
          { title: "Home", to: "/home" },
          { title: "Municípios", to: "/municipios" }
        ],
        "cadastro-municipio": [
          { title: "Home", to: "/home" },
          { title: "Municípios", to: "/municipios" },
          { title: "Cadastro de Município", to: "" }
        ],
        ufs: [
          { title: "Home", to: "/home" },
          { title: "UFs", to: "/ufs" }
        ],
        configuracoes: [
          { title: "Home", to: "/home" },
          { title: "Configurações", to: "/configuracoes" }
        ],
      };
      return map[this.$route.name] || [{ title: "Home", to: "/home" }];
    }
  },
  mounted() {
    this.updateTitle(this.$route);
  },
  watch: {
    $route(value) {
      this.updateTitle(value);
    },
    drawer(value) {
      localStorage.setItem("drawerState", value);
    },
  },
  methods: {
    logout() {
      sessionStorage.removeItem("token");
      this.$router.push({ name: "login" });
    },
    updateTitle(route) {
      switch (route.name) {
        case "home":
          this.title = "Home";
          break;
        case "clientes":
          this.title = "Clientes";
          break;
        case "editar-cliente":
          this.title = "Edição de Cliente";
          break;
        case "cadastro-cliente":
          this.title = "Cadastro de Cliente";
          break;
        case "municipios":
          this.title = "Municípios";
          break;
        case "ufs":
          this.title = "UFs";
          break;
        case "licenca-detalhe":
          this.title = "Detalhe da Licença";
          break;
        default:
          this.title = "";
          break;
      }
    },
  }
};
</script>

<style scoped>
.fade-breadcrumbs-enter-active,
.fade-breadcrumbs-leave-active {
  transition: opacity 0.35s cubic-bezier(.4,0,.2,1);
}
.fade-breadcrumbs-enter-from,
.fade-breadcrumbs-leave-to {
  opacity: 0;
}
.fade-breadcrumbs-enter-to,
.fade-breadcrumbs-leave-from {
  opacity: 1;
}
.custom-app-bar {
  border-bottom: 1.5px solid #e3e7ed;
  background: #f5f5f5 !important;
  min-height: 70px;
}
.logo-img {
  margin-left: 12px;
  margin-top: 2px;
  filter: grayscale(0.1) brightness(0.98);
}
.smooth-title {
  transition:
    margin-bottom 0.45s cubic-bezier(.4,0,.2,1),
    font-size 0.45s cubic-bezier(.4,0,.2,1),
    color 0.45s cubic-bezier(.4,0,.2,1),
    letter-spacing 0.45s cubic-bezier(.4,0,.2,1);
  margin-bottom: 0.15rem;
}
.smooth-title.with-breadcrumbs {
  margin-bottom: 0.45rem;
  font-size: 1.25rem;
  color: #1756a9;
  letter-spacing: 0.7px;
}
.main-title {
  font-size: 1.35rem;
  font-weight: 700;
  color: #1976d2;
  letter-spacing: 0.5px;
}
.breadcrumbs-bar {
  margin-top: 2px;
  margin-bottom: 0;
  padding-bottom: 0;
  font-size: 1.01rem;
  text-align: left;
  transition: opacity 0.35s cubic-bezier(.4,0,.2,1);
}
.subtitle {
  font-size: 1.05rem;
  color: #6f6f6f;
  margin-top: 2px;
  font-weight: 500;
  letter-spacing: 0.2px;
}
.logout-btn {
  transition: background 0.18s;
}
.logout-btn:hover {
  background: #ffeaea !important;
}
.custom-drawer {
  border-right: 1.5px solid #e3e7ed;
  background: #f5f5f5 !important;
  min-width: 220px;
}
.drawer-item {
  border-radius: 10px;
  margin: 2px 6px;
  transition: background 0.18s, color 0.18s;
}
.drawer-item.active,
.drawer-item.router-link-exact-active {
  background: linear-gradient(90deg, #e3f0ff 0%, #f5fafd 100%);
  color: #1976d2 !important;
  font-weight: 600;
}
.drawer-item:hover {
  background: #f0f4ff;
  color: #1976d2 !important;
}
.drawer-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
  padding-bottom: 10px;
}
.logout-btn-wrapper {
  display: inline-block;
  position: relative;
}
.logout-tooltip {
  position: absolute;
  right: 110%;
  top: 50%;
  transform: translateY(-50%);
  background: #ffeaea;
  color: #d32f2f;
  border-radius: 6px;
  padding: 4px 14px;
  font-size: 1rem;
  font-weight: 500;
  white-space: nowrap;
  box-shadow: 0 2px 8px 0 rgba(211,47,47,0.08);
  z-index: 10;
  opacity: 1;
  transition: opacity 0.18s;
}
.fade-logout-enter-active,
.fade-logout-leave-active {
  transition: opacity 0.18s;
}
.fade-logout-enter-from,
.fade-logout-leave-to {
  opacity: 0;
}
.fade-logout-enter-to,
.fade-logout-leave-from {
  opacity: 1;
}
@media (max-width: 600px) {
  .custom-app-bar {
    min-height: 56px;
  }
  .main-title {
    font-size: 1.1rem;
  }
  .breadcrumbs-bar {
    font-size: 0.95rem;
  }
  .subtitle {
    font-size: 0.95rem;
  }
  .custom-drawer {
    min-width: 140px;
  }
}
</style>
